<div class="task-window">
  <header class="task-header">
    <div class="header-icon"><mat-icon>{{ mode === 'create' ? 'add_task' : mode === 'edit' ? 'edit_note' : 'assignment' }}</mat-icon></div>
    <div *ngIf="activity == 'expense'" class="header-text">
      <h2>{{ mode === 'create' ? 'Nouvelle Dépense' : mode === 'edit' ? 'Modifier la Dépense' : 'Détails de la Dépense' }}</h2>
      <p>{{ mode === 'create' ? 'Créez et attribuez une dépense à votre équipe.' : mode === 'edit' ? 'Modifiez les informations de cette dépense.' : 'Consultez les informations de cette dépense.' }}</p>
    </div>
    <div *ngIf="activity == 'task'"  class="header-text">
      <h2>{{ mode === 'create' ? 'Nouvelle tâche' : mode === 'edit' ? 'Modifier la tâche' : 'Détails de la tâche' }}</h2>
      <p>{{ mode === 'create' ? 'Créez et attribuez une tâche à votre équipe.' : mode === 'edit' ? 'Modifiez les informations de cette tâche.' : 'Consultez les informations de cette tâche.' }}</p>
    </div>
    <button type="button" class="icon-button" aria-label="Fermer" (click)="close()"><mat-icon>close</mat-icon></button>
  </header>

  <div style="height: 95dvh; max-height: 95dvh; display: flex; flex-direction: column; overflow: hidden;">
        <form [formGroup]="activityForm" (ngSubmit)="saveTask()" class="task-form" tyle="flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden;">
            <div class="task-body">
            <section class="form-section">
                <div class="section-heading"><mat-icon>description</mat-icon><h3>Informations générales</h3></div>

                <div class="field">
                    <label for="task-title">Titre <span class="required">*</span></label>
                    <input id="task-title" type="text" formControlName="title" placeholder="Ex. Développer le tableau de bord">
                    <small class="error" *ngIf="activityForm.get('title')?.touched && activityForm.get('title')?.hasError('required')">Le titre est obligatoire.</small>
                </div>
                <div *ngIf="activity == 'expense'" style="position: relative; float: right; display: flex; margin-left: auto; align-items: center; ">
                    <span class="switch-toggle" [ngClass]="{'switch-checked': isInternalExpense}" (click)="toggleInternalExpense()">
                    <small></small>
                    </span>
                    <label class="filter-label">Dépense Interne</label>
                </div>

                <div class="field">
                    <label for="task-objective">Objectif</label>
                    <input id="task-objective" type="text" formControlName="objective" placeholder="Quel est le résultat attendu ?">
                </div>

                <div class="field-grid">
                    <div class="field">
                        <label>Catégorie <span class="required">*</span></label>
                        <mat-select formControlName="id_category" placeholder="Choisir une catégorie">
                            <mat-option *ngFor="let category of categories" [value]="category.id">{{ category.name_fr}}</mat-option>
                        </mat-select>
                        <small class="error" *ngIf="activityForm.get('id_category')?.touched && activityForm.get('id_category')?.hasError('required')">Choisissez une catégorie.</small>
                    </div>
                    <div *ngIf="activity == 'expense'" class="field">
                        <label>Couverture de la dépense <span class="required">*</span></label>
                        <mat-select formControlName="coverage" placeholder="Choisir la couverture">
                            <mat-option *ngFor="let element of expenseCoverage" [value]="element.keyword">{{element.name_fr}}</mat-option>
                        </mat-select>
                        <small class="error" *ngIf="activityForm.get('coverage')?.touched && activityForm.get('coverage')?.hasError('required')">Choisissez une couverture.</small>
                    </div>
                    <div *ngIf="activity == 'task'" class="field">
                        <label>Priorité <span class="required">*</span></label>
                        <mat-select formControlName="priority" placeholder="Choisir une priorité">
                            <mat-option *ngFor="let element of taskPriorities" [value]="element.keyword">{{element.name_fr}}</mat-option>
                        </mat-select>
                        <small class="error" *ngIf="activityForm.get('priority')?.touched && activityForm.get('priority')?.hasError('required')">Définissez la priorité.</small>
                    </div>
                </div>
                <div class="field">
                    <label for="task-description">Description</label>
                    <textarea id="task-description" formControlName="description" rows="4" placeholder="Décrivez le travail à réaliser..."></textarea>
                </div>
            </section>
            <section *ngIf="activity === 'expense'" class="form-section">
                <div class="section-heading"><mat-icon>payments</mat-icon><h3>Dépense et paiement</h3></div>
                <div class="field-grid">
                    <div class="field">
                        <label for="amount_euro">Montant (€) <span class="required">*</span></label>
                        <input id="amount_euro" type="number" formControlName="amount_euro" min="0" step="0.01" placeholder="Ex. 50,00 €" (input)="convertFromEuro()">
                        <small class="error" *ngIf="activityForm.get('amount_euro')?.touched && activityForm.get('amount_euro')?.hasError('required')">Renseignez le montant (€).</small>
                    </div>
                    <div class="field">
                        <label for="amount_cfa">Montant (CFA)</label>
                        <input id="amount_cfa" type="number" formControlName="amount_cfa" min="0" step="0.01" placeholder="Ex. 32 798 FCFA" (input)="convertFromCfa()">
                    </div>
                </div>
                <div class="field-grid">
                    <div class="field">
                        <label>Statut</label>
                        <mat-select formControlName="status" placeholder="Choisir un statut">
                            <mat-option *ngFor="let element of expenseStatus" [value]="element.keyword">{{element.name_fr}}</mat-option>
                        </mat-select>
                        <small class="error" *ngIf="activityForm.get('status')?.touched && activityForm.get('status')?.hasError('required')">Renseignez le statut.</small>
                    </div>
                    <div class="field">
                        <label>Date de paiement <span *ngIf="activityForm.get('status')?.value == 'paid'" class="required">*</span></label>
                        <div class="date-control">
                            <mat-icon>event_available</mat-icon>
                            <input [matDatepicker]="payedDatePicker" formControlName="payed_date" placeholder="Sélectionner une date">
                            <mat-datepicker-toggle [for]="payedDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #payedDatePicker></mat-datepicker>
                        </div>
                        <small class="error" *ngIf="activityForm.get('status')?.value == 'paid' && activityForm.get('payed_date')?.touched && activityForm.get('payed_date')?.hasError('required')">Choisissez une date de paiement.</small>
                    </div>
                </div>
                <div class="field" *ngIf="!isInternalExpense && activityForm.get('expense_mode')?.value !== 'ponctual'">
                    <label>Période concernée <span class="required">*</span></label>
                    <div class="date-control">
                        <mat-date-range-input [rangePicker]="expenseDatePicker">
                            <input matStartDate formControlName="start_date" placeholder="Date de début">
                            <input matEndDate formControlName="end_date" placeholder="Date de fin">
                        </mat-date-range-input>
                        <mat-datepicker-toggle [for]="expenseDatePicker"></mat-datepicker-toggle>
                        <mat-date-range-picker #expenseDatePicker></mat-date-range-picker>
                    </div>
                    <small class="error" *ngIf="(activityForm.get('start_date')?.touched && activityForm.get('start_date')?.hasError('required')) || (activityForm.get('end_date')?.touched && activityForm.get('end_date')?.hasError('required'))">Choisissez un interval de date.</small>
                </div>
                <div class="field" *ngIf="isInternalExpense">
                    <label>Vagues concernées <span class="required">*</span></label>
                    <mat-select placeholder="Set Waves" formControlName="waves" class="multiselect" multiple>
                        <mat-option [value]="element['id']" *ngFor="let element of userWaves; let i = index">
                            <span class="mat-option-content">{{element['name_fr']}}</span>
                            <span class="mat-option-checkbox">
                                <mat-icon *ngIf="selectedElement('waves', element)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon>
                            </span>
                        </mat-option>
                    </mat-select>
                    <small class="error" *ngIf="activityForm.get('waves')?.touched && activityForm.get('waves')?.hasError('required')">Renseignez les vagues.</small>
                </div>
            </section>

            <section *ngIf="activity == 'task'" class="form-section">
                <div class="section-heading"><mat-icon>tune</mat-icon><h3>Suivi et planification</h3></div>
                <div class="field-grid">
                    <div class="field">
                        <label>Statut</label>
                        <mat-select formControlName="status" placeholder="Choisir un statut">
                            <mat-option *ngFor="let element of taskStatus" [value]="element.keyword">{{element.name_fr}}</mat-option>
                        </mat-select>
                        <small class="error" *ngIf="activityForm.get('status')?.touched && activityForm.get('status')?.hasError('required')">Renseignez le statut.</small>
                    </div>
                    <div class="field">
                        <label for="task-progress">Progression (%)</label>
                        <div class="progress-control">
                            <mat-slider min="0" max="100" step="5" discrete>
                                <input matSliderThumb formControlName="progress">
                            </mat-slider>
                            <strong>{{ activityForm.get('progress')?.value }}%</strong>
                        </div>
                    </div>
                </div>

                <div class="field">
                    <label>Période de réalisation</label>
                    <div class="date-control" >
                        <mat-date-range-input [rangePicker]="taskDatePicker">
                            <input matStartDate formControlName="start_date" placeholder="Date de début">
                            <input matEndDate formControlName="end_date" placeholder="Date d'échéance">
                        </mat-date-range-input>
                        <mat-icon matDatepickerToggleIcon fontIcon="close_small" style="font-size: 18px; display: flex; align-items: center;" (click)="resetDates()"></mat-icon>
                        <mat-datepicker-toggle [for]="taskDatePicker"></mat-datepicker-toggle>
                        <mat-date-range-picker #taskDatePicker></mat-date-range-picker>
                    </div>
                </div>
                
                <div class="field">
                    <label>Date de fin réelle <span *ngIf="activityForm.get('status')?.value == 'done'" class="required">*</span></label>
                    <div class="date-control">
                        <mat-icon>event_available</mat-icon>
                        <input [matDatepicker]="completedPicker" formControlName="completed_date" placeholder="Date de fin">
                        <mat-datepicker-toggle matSuffix [for]="completedPicker"></mat-datepicker-toggle>
                        <mat-datepicker #completedPicker></mat-datepicker>
                    </div>
                    <small class="error" *ngIf="activityForm.get('status')?.value == 'done' && activityForm.get('completed_date')?.touched && activityForm.get('completed_date')?.hasError('required')">Renseignez la date de fin.</small>
                </div>

                <div class="field-grid">
                    <div class="field">
                        <label for="estimated-hours">Temps estimé (heures)</label>
                        <input id="estimated-hours" type="number" formControlName="estimated_hours" min="0" step="0.5" placeholder="Ex. 12">
                    </div>
                    <div class="field">
                        <label for="completed-hours">Temps réalisé (heures) <span *ngIf="activityForm.get('status')?.value == 'done'" class="required">*</span></label>
                        <input id="completed-hours" type="number" formControlName="completed_hours" min="0" step="0.5" placeholder="Ex. 7">
                        <small class="error" *ngIf="activityForm.get('status')?.value == 'done' && activityForm.get('completed_hours')?.touched && activityForm.get('completed_hours')?.hasError('required')">Renseignez la en durée.</small>
                    </div>
                </div>
            </section>
            <section *ngIf="activity == 'expense'" class="form-section full-section">
                <div class="section-heading"><mat-icon>groups</mat-icon><h3>Responsables</h3></div>
                <div class="field-grid">
                    <div class="field">
                        <label>Responsable dépense <span class="required">*</span></label>
                        <mat-select formControlName="id_user_assigned" placeholder="Sélectionner un responsable" (selectionChange)="onExpenseOwnerChange($event.value)">
                            <input class="col-input-filter" [formControl]="userAssignedControl">
                             <mat-select-trigger>{{ selectedUserExpenseOwner?.full_name || 'Choisir un bénéficiaire' }}</mat-select-trigger>
                            <mat-option *ngFor="let user of usersAssigned" [value]="user.id">
                                <span class="option-user"><span class="avatar small-avatar" [style.background]="user.color || '#016F86'">{{ user.initials }}</span><span><strong>{{ user.full_name }}</strong><small>{{ user.email }} · {{ user.phone }}</small></span></span>
                            </mat-option>
                        </mat-select>
                        <small class="error" *ngIf="activityForm.get('id_user_assigned')?.touched && activityForm.get('id_user_assigned')?.hasError('required')">Choisissez un responsable.</small>
                        
                    </div>
                    <div class="field">
                        <label for="user_beneficiary">Beneficiaire</label>
                        <mat-select *ngIf="isInternalExpense" formControlName="id_user_beneficiary" placeholder="Choisir un beneficiaire" (selectionChange)="onBeneficiaryChange($event.value)">
                            <input class="col-input-filter" [formControl]="userBeneficiaryControl">
                            <mat-select-trigger>{{ selectedUserExpenseBeneficiary?.full_name || 'Choisir un bénéficiaire' }}</mat-select-trigger>
                            <mat-option *ngFor="let user of usersBeneficiary" [value]="user.id">
                                <span class="option-user"><span class="avatar small-avatar" [style.background]="user.color || '#016F86'">{{ user.initials }}</span><span><strong>{{ user.full_name }}</strong><small>{{ user.email }} · {{ user.phone }}</small></span></span>
                            </mat-option>
                        </mat-select>
                        <input *ngIf="!isInternalExpense" id="user_beneficiary" type="text" formControlName="objective" placeholder="Définir un beneficiaire">
                    </div>
                </div>
                <div class="expense-recap" *ngIf="isInternalExpense && expenseSections.length">
                    <!-- HEADER / TOTAL -->
                    <div class="recap-header">
                        <div class="recap-title">
                            <h3>Récapitulatif des interventions</h3>
                            <small>Détail des travaux et montants à régler</small>
                        </div>
                        <div class="recap-total">
                            <small>TOTAL À PAYER</small>
                            <strong>{{ totalExpense | number:'1.0-0' }} FCFA</strong>
                            <span>{{ totalContent }} contenus · {{ expenseSections.length }} intervention(s)</span>
                        </div>
                    </div>
                    <mat-accordion multi>
                        <mat-expansion-panel *ngFor="let section of expenseSections" [expanded]="true">

                            <mat-expansion-panel-header>
                                <mat-panel-title>{{ section.title }}</mat-panel-title>
                                <mat-panel-description>{{ section.total | number:'1.0-0' }} FCFA</mat-panel-description>
                            </mat-expansion-panel-header>

                            <div class="section-summary">
                                <span>{{ section.rows.length }} intervenant(s)</span>
                                <span>{{ section.nbContent | number }} contenus</span>
                                <span *ngIf="section.type === 'edition'">{{ section.nbWord | number }} mots</span>
                            </div>
                            <div class="table-container">
                                <table mat-table [dataSource]="section.rows">
                                    <ng-container matColumnDef="user">
                                        <th mat-header-cell *matHeaderCellDef>Intervenant</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="user-cell"><strong>{{ row.full_name }}</strong><small *ngIf="row.manager_full_name"> ({{ row.manager_full_name }}) </small>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="wave">
                                        <th mat-header-cell *matHeaderCellDef>Vague</th>
                                        <td mat-cell *matCellDef="let row">{{ row.wave }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="origin">
                                        <th mat-header-cell *matHeaderCellDef>Cycle</th>
                                        <td mat-cell *matCellDef="let row">
                                            {{ row.origin === 'virtualclass' ? 'Secondaire' : 'Universitaire' }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nb_content">
                                        <th mat-header-cell *matHeaderCellDef>Contenus</th>
                                        <td mat-cell *matCellDef="let row">{{ row.nb_content | number }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="nb_word">
                                        <th mat-header-cell *matHeaderCellDef>Mots</th>
                                        <td mat-cell *matCellDef="let row">{{ row.nb_word | number }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="unit_price">
                                        <th mat-header-cell *matHeaderCellDef>{{ section.type === 'edition' ? 'Tarif / 300 mots' : 'Tarif unitaire' }}</th>
                                        <td mat-cell *matCellDef="let row">{{ row.unit_price | number:'1.0-0' }} FCFA</td>
                                    </ng-container>

                                    <ng-container matColumnDef="price">
                                        <th mat-header-cell *matHeaderCellDef>Total</th>
                                        <td mat-cell *matCellDef="let row"><strong>{{ row.price | number:'1.0-0' }} FCFA</strong></td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="section.displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: section.displayedColumns"></tr>

                                </table>
                            </div>

                            <!-- SECTION TOTAL -->
                            <div class="section-total">
                                <span>Sous-total {{ section.title }}</span>
                                <strong>{{ section.total | number:'1.0-0' }} FCFA</strong>
                            </div>

                        </mat-expansion-panel>
                    </mat-accordion>
                </div>

                <div class="empty-recap" *ngIf="isInternalExpense && !expenseSections.length">
                    <mat-icon>receipt_long</mat-icon>
                    <strong>Aucune intervention enregistrée</strong>
                    <small>Le récapitulatif apparaîtra dès que des interventions seront disponibles.</small>
                </div>
            </section>

            <section *ngIf="activity == 'task'" class="form-section full-section">
                <div class="section-heading"><mat-icon>groups</mat-icon><h3>Responsables</h3></div>
                <div class="field">
                    <label>Responsables assignés <span class="required">*</span></label>
                    <mat-select formControlName="id_user_assigned" multiple placeholder="Sélectionner des utilisateurs">
                        <mat-select-trigger>{{ selectedUsersAssigned.length ? selectedUsersAssigned.length + ' utilisateur(s) sélectionné(s)' : 'Sélectionner des utilisateurs' }}</mat-select-trigger>
                        <input class="col-input-filter" [formControl]="userAssignedControl">
                        <mat-option *ngFor="let user of usersAssigned" [value]="user.id">
                            <span class="option-user"><span class="avatar small-avatar" [style.background]="user.color || '#016F86'">{{ user.initials  }}</span><span><strong>{{ user.full_name }}</strong><small>{{ user.email }} · {{ user.phone }}</small></span></span>
                        </mat-option>
                    </mat-select>
                    <small class="error" *ngIf="activityForm.get('category')?.touched && activityForm.get('id_user_assigned')?.hasError('required')">Choisissez un responsable.</small>
                    <div class="assigned-users" *ngIf="selectedUsersAssigned.length">
                        <div class="user-chip" *ngFor="let user of selectedUsersAssigned">
                        <span class="avatar" [style.background]="user.color || '#016F86'">{{ user.initials }}</span>
                        <span class="chip-name">{{ user.full_name }}</span>
                        <button type="button" *ngIf="!isViewMode" aria-label="Retirer l'utilisateur" (click)="removeUser(user.id)"><mat-icon>close</mat-icon></button>
                        </div>
                    </div>
                    <small class="error" *ngIf="activityForm.get('id_user_assigned')?.touched && activityForm.get('id_user_assigned')?.hasError('required')">Choisissez les responsables.</small>
                </div>
            </section>

            <section class="form-section full-section">
                <div class="section-heading"><mat-icon>attach_file</mat-icon><h3>Pièces jointes <span class="count-badge">{{ attachments.length }}</span></h3></div>
                <div class="attachment-list" *ngIf="attachments.length">
                <div class="attachment-item" *ngFor="let file of attachments; let i = index">
                    <div class="file-icon"><mat-icon>description</mat-icon></div>
                    <div class="attachment-info"><strong>{{ file.name }}</strong><small>{{ file.size || 'Fichier joint' }}</small></div>
                    <button type="button" class="icon-button small-icon-button" *ngIf="file.path" aria-label="Ouvrir le fichier" (click)="openAttachment(file)"><mat-icon>open_in_new</mat-icon></button>
                    <button type="button" class="icon-button small-icon-button" *ngIf="!isViewMode" aria-label="Supprimer le fichier" (click)="removeAttachment(i)"><mat-icon>delete_outline</mat-icon></button>
                </div>
                </div>
                <label class="upload-zone" *ngIf="!isViewMode">
                <mat-icon>cloud_upload</mat-icon><span><strong>Ajouter des fichiers</strong><small>Choisissez un ou plusieurs fichiers depuis votre appareil</small></span>
                <input type="file" multiple (change)="onFilesSelected($event)">
                </label>
                <p class="empty-state" *ngIf="!attachments.length && isViewMode">Aucune pièce jointe.</p>
            </section>

            <section class="form-section full-section">
                <div class="section-heading"><mat-icon>chat_bubble_outline</mat-icon><h3>Commentaires <span class="count-badge">{{ comments.length }}</span></h3></div>
                <div class="comment-list" *ngIf="comments.length">
                <div class="comment-item" *ngFor="let comment of comments">
                    <span class="avatar" [style.background]="comment.color || '#016F86'">{{ comment.initials || '..'}}</span>
                    <div class="comment-content">
                    <div class="comment-meta"><strong>{{ comment.first_name || 'Utilisateur' }}</strong><small>{{ comment.date ? (comment.date | date:'dd/MM/yyyy HH:mm') : '' }}</small></div>
                    <p>{{ comment.message || comment.text }}</p>
                    </div>
                </div>
                </div>
                <p class="empty-state" *ngIf="!comments.length">Aucun commentaire pour le moment.</p>
                <div class="comment-entry" *ngIf="!isViewMode">
                <textarea [(ngModel)]="newComment" [ngModelOptions]="{standalone: true}" rows="2" placeholder="Écrire un commentaire..."></textarea>
                <button type="button" class="comment-send" aria-label="Ajouter le commentaire" [disabled]="!newComment.trim()" (click)="addComment()"><mat-icon>send</mat-icon></button>
                </div>
            </section>
            </div>
            <footer class="task-footer">
                <button type="button" class="btn-secondary" (click)="close()">Annuler</button>
                <button type="submit" class="btn-primary" *ngIf="!isViewMode"><mat-icon>check</mat-icon>{{ mode === 'edit' ? 'Enregistrer les modifications' : 'Enregistrer' }}</button>
            </footer>
        </form>
  </div>
</div>